import A from 'components/atoms/A/A';
import LocaleAwareImage from 'components/atoms/LocaleAwareImage/LocaleAwareImage';
import RegistrationCard from 'components/atoms/RegistrationCard/RegistrationCard';
import UsernameInput, { FORM_KEY } from 'components/atoms/TextInput/UsernameInput';
import Txt from 'components/atoms/Txt/Txt';
import Form from 'components/molecules/Form/Form';
import useFrontEndEventTrigger from 'hooks/useFrontEndEventTrigger';
import React, { useRef } from 'react';
import { StepProps } from './RegistrationForm';
import classes from './RegistrationForm.module.scss';
import SocialSignUpButtons from './SocialSignUpButtons';

export const EMAIL_REQUIREMENT_DESCRIPTIONS = 'Please enter a valid email address';

export function InitialEmailStep({ onNext, currentFormData, menu, error }: StepProps) {
  const isSocial = Boolean(currentFormData.provider || currentFormData.socialToken);
  const { frontEndEventTrigger } = useFrontEndEventTrigger();

  function handleSubmit(formData: FormData) {
    onNext?.({
      username: formData.get(FORM_KEY)?.toString() ?? '',
    });
    frontEndEventTrigger('Registration step', 'Initial email');
  }

  return (
    <div className={classes.registrationFormContainer}>
      <RegistrationCard
        title="Start Earning Today"
        menu={menu}
        additionalInfo={{
          title: 'Earn money by completing surveys',
          subtitle: (
            <>
              <Txt component={'p'}>
                Paid surveys are a convenient side hustle for anyone who wants to earn a little
                extra.
              </Txt>
              <Txt component={'p'}>
                Earn points for each survey you complete and use them to get cash or gift cards.
              </Txt>
            </>
          ),
          image: (
            <LocaleAwareImage
              alt=""
              src="/assets/registration-initial.png"
              width={431}
              height={234}
            />
          ),
        }}
      >
        {error}
        <Txt component={'p'}>
          Sign up for free and start making money by completing surveys every day.
        </Txt>
        <Form
          submitName="Sign Up"
          submitButtonType="primary"
          submitButtonClassName={classes.nextButton}
          onSubmit={handleSubmit}
          className={classes.formOverrides}
        >
          <UsernameInput
            autoFocus={!isSocial}
            readOnly={isSocial}
            defaultValue={currentFormData.username}
          />
        </Form>
        <SocialSignUpButtons />
        <div className={classes.reportProblemWrapper}>
          <A className={classes.reportProblem} href="/member/zendeskhelp/new">
            <Txt>Report a problem</Txt>
          </A>
        </div>
      </RegistrationCard>
    </div>
  );
}
